import React, { useEffect, useState } from 'react'
import Input from "../../../../../../core/Inputs/DefaultInput";
import { useDispatch } from 'react-redux';
import { changeAddSurveyFormData } from '../../../../../../store/actions/surveyAction';
import { useTranslation } from 'react-i18next';

export default function QuestionScreen2({ changeScreen }) {
    //States
    const [title, setTitle] = useState('')
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();

    //Functionality
    const onSubmit = () => {
        if (!isSurveyNameValid()) {
            return
        }
        dispatch(changeAddSurveyFormData('survey_title', title))
        changeScreen('INCREMENT')
    }

    const isSurveyNameValid = () => {
        if (title === '') {
            setError(t('survey.question.texts'))
            return false
        }
        setError(null)
        return true
    }

    return (
        <div className="new-survery-screen text-center">
            <a className="cancel-btn" data-bs-toggle="modal" data-bs-target="#cancelSurvey">
                <svg width={19} height={18} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L17 17" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M17 1L1 17" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </a>
            <div className="surv-question-wrap">
                <div className="text-wrapper">
                    <h2 className="question">{t('survey.ques2')}</h2>
                    <div className="input-wrap mb-5 position-relative">
                        <Input
                            type='text'
                            view='outlined'
                            dense={false}
                            color='default'
                            label=''
                            placeholder={t('survey.enter')}
                            success={false}
                            fill={true}
                            value=""
                            className={"formsinput font-bold"}
                            onBlur={() => isSurveyNameValid()}
                            onInput={e => setTitle(e.target.value)}
                        />
                        {error && <div className="validation-msg">{error}</div>}
                    </div>
                    <button className='btn btn-primary next-btn' onClick={() => onSubmit()}>{t('survey.next')}</button>
                </div>
            </div>
        </div>
    )
}
